import React from "react";
import DevicesList from "./DevicesList";
import DistributionDrawer from "./DistributionDrawer";

function DeviceOverview({
  deviceDetailIsLoading,
  deviceDetailIsFetching,
  devicesData = [],
  totalDevices = 0,
  deviceRevised,
  onDeviceClick = null,
  operationHandler = null,
  setOperationHandler = null,
  selectedOperationDevice,
  setSelectedOperationDevice,
  deviceDetailClick,
  setDeviceDetailClick,
  searchParams,
  onSearchParamsChange,
  onPageChange,
  pagination,
  getDeviceDetail,
  authToken,
  distributionData = null,
  distributionLoading = false,
  isDealer = false,
}) {
  return (
    <div className="flex flex-col relative flex-1 min-h-0 h-full">
      <div className="w-full flex-1 min-h-0 flex flex-col">
        <DevicesList
          deviceDetailIsLoading={deviceDetailIsLoading}
          deviceDetailIsFetching={deviceDetailIsFetching}
          onDeviceClick={onDeviceClick}
          devicesData={devicesData}
          height={500}
          className="h-full"
          deviceRevised={deviceRevised}
          operationHandler={operationHandler}
          setOperationHandler={setOperationHandler}
          selectedOperationDevice={selectedOperationDevice}
          setSelectedOperationDevice={setSelectedOperationDevice}
          searchParams={searchParams}
          onSearchParamsChange={onSearchParamsChange}
          onPageChange={onPageChange}
          pagination={pagination}
          getDeviceDetail={getDeviceDetail}
          authToken={authToken}
          isDealer={isDealer}
        />
      </div>

      <DistributionDrawer
        open={deviceDetailClick === "all"}
        onClose={() => setDeviceDetailClick(false)}
        devicesData={devicesData}
        totalDevices={totalDevices}
        distributionData={distributionData}
        distributionLoading={distributionLoading}
      />
    </div>
  );
}

export default DeviceOverview;
